export function getWalletRecoveryAction(status) {
  if (status === "succeeded" || status === "requires_capture") return "complete";
  if (status === "processing") return "wait";
  if (status === "requires_payment_method") return "reset";
  if (status === "canceled") return "expired";
  return "none";
}
